import request from '@host-panel/request';

import { TokenStatusResponse } from './ssoTypes';

export function getTokenStatus(): Promise<TokenStatusResponse> {
  return request(`/host-panel/sso/token-status`, {
    method: 'GET'
  });
}

export function activateTokenRequest(token: string) {
  return request(`/host-panel/sso/activate-token`, {
    method: 'POST',
    data: {
      token
    }
  });
}

export function inspectCodeBRequest(codeB: string): Promise<string> {
  return request(`/host-panel/sso/inspect-code-b/${codeB}`, {
    method: 'GET'
  });
}
